<template>
 <v-layout row wrap align-end justify-end>
    <br v-if="env_show != 'true'" />
    <v-flex v-if="env_show == 'true'">
      <v-chip label class="mb-2 py-5" color="#FF0064">
        <h4 class="white--text pr-1">{{ $t("test_system.title") }}</h4>
        <span v-if="!($vuetify.breakpoint.xsOnly)" 
          class="white--text pr-1" style="font-size: 12px"
          >{{ $t("test_system.detail") }}
        </span>
      </v-chip>
    </v-flex>
    <br v-if="env_show != 'true'" />
 </v-layout>
</template>
<script>
export default {
  props: ["show", "html"],
  mounted() {},
  computed: {
    env_show: {
      get() {
        return process.env.VUE_APP_SHOW_TEST;
      },
    },
  },
};
</script>


<style scoped>
</style>